module.exports = __webpack_public_path__ + "img/img-29.1dd57a8b.png";